module.exports = __webpack_public_path__ + "static/group3_5-b3a673a24810085a5c4459e3137407c7.webp";